"use strict";

exports.__esModule = true;
exports.default = createUtilityClassName;
exports.responsivePropType = responsivePropType;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("./ThemeProvider");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function responsivePropType(propType) {
  return _propTypes.default.oneOfType([propType, _propTypes.default.shape({
    xs: propType,
    sm: propType,
    md: propType,
    lg: propType,
    xl: propType,
    xxl: propType
  })]);
}
function createUtilityClassName(utilityValues) {
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ThemeProvider.DEFAULT_BREAKPOINTS;
  var minBreakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ThemeProvider.DEFAULT_MIN_BREAKPOINT;
  var classes = [];
  Object.entries(utilityValues).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      utilName = _ref2[0],
      utilValue = _ref2[1];
    if (utilValue != null) {
      if (_typeof(utilValue) === 'object') {
        breakpoints.forEach(function (brkPoint) {
          var bpValue = utilValue[brkPoint];
          if (bpValue != null) {
            var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : '';
            classes.push("".concat(utilName).concat(infix, "-").concat(bpValue));
          }
        });
      } else {
        classes.push("".concat(utilName, "-").concat(utilValue));
      }
    }
  });
  return classes;
}